import React from 'react';
import { CONTACT } from '@/utils/format';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-[#1C1917] text-[#FDFBF7] mt-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="mb-4 bg-white/95 rounded-2xl px-4 py-3 inline-flex">
              <Logo size="lg" variant="lockup" />
            </div>
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              Nutrición premium, holística y especializada para perros y gatos en Colombia.
            </p>
            <div className="flex gap-3">
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#2A5C43] flex items-center justify-center">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#2A5C43] flex items-center justify-center">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.15em] mb-4">Comprar</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/perros" className="hover:text-[#D47A4A]">Alimento para perros</Link></li>
              <li><Link to="/gatos" className="hover:text-[#D47A4A]">Alimento para gatos</Link></li>
              <li><Link to="/marcas" className="hover:text-[#D47A4A]">Todas las marcas</Link></li>
              <li><Link to="/perros?is_grain_free=true" className="hover:text-[#D47A4A]">Libre de granos</Link></li>
              <li><Link to="/perros?is_specialized=true" className="hover:text-[#D47A4A]">Nutrición especializada</Link></li>
              <li><Link to="/ofertas" className="hover:text-[#D47A4A]">Ofertas</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.15em] mb-4">Ayuda</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/faq" className="hover:text-[#D47A4A]">Preguntas frecuentes</Link></li>
              <li><Link to="/envios" className="hover:text-[#D47A4A]">Política de envíos</Link></li>
              <li><Link to="/cambios-devoluciones" className="hover:text-[#D47A4A]">Cambios y devoluciones</Link></li>
              <li><Link to="/terminos" className="hover:text-[#D47A4A]">Términos y condiciones</Link></li>
              <li><Link to="/privacidad" className="hover:text-[#D47A4A]">Política de privacidad</Link></li>
              <li><Link to="/tratamiento-datos" className="hover:text-[#D47A4A]">Tratamiento de datos (Ley 1581)</Link></li>
              <li><Link to="/contacto" className="hover:text-[#D47A4A]">Contacto</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.15em] mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Bogotá, Colombia</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{CONTACT.phoneDisplay}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{CONTACT.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>© 2026 Nutripetgourmet. Todos los derechos reservados.</p>
          <p>Precios en pesos colombianos (COP) con IVA incluido</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
